<script>
  import ButtonContainer from "@helpers/ButtonContainer.svelte";
  import departments from "@data/departments.json";

  let showAll = false;

  const departmentsWithSearchText = departments.map(
    ({ ["Department Description"]: deptDesc, ...rest }) => ({
      ...rest,
      "Department Description": deptDesc,
      searchText: Object.values(rest).join(" ").toLowerCase(),
    })
  );

  // If user has selected departments, show them + the other top 10
  $: filteredItems = showAll
    ? departmentsWithSearchText
        .filter((d) => d.Include)
        .sort((a, b) => a.Top10 - b.Top10)
        .sort(
          (a, b) => (typeof b.Top10 == "number") - (typeof a.Top10 == "number")
        )
        .sort(
          (a, b) =>
            $topFourDepartments
              .map((d) => d.Department)
              .includes(b.Department) -
            $topFourDepartments.map((d) => d.Department).includes(a.Department)
        )
    : departmentsWithSearchText
        .filter((d) => d.Include)
        .filter(
          (d) => typeof d.Top10 == "number" || $topFourDepartments.includes(d)
        )
        .sort((a, b) => a.Top10 - b.Top10)
        .sort(
          (a, b) =>
            $topFourDepartments
              .map((d) => d.Department)
              .includes(b.Department) -
            $topFourDepartments.map((d) => d.Department).includes(a.Department)
        );

  $: departmentsAfterSearch = filteredItems.slice();

  let rankings = $topFourDepartments.length > 0 ? $topFourDepartments : [];

  $: canSubmit = false;
  $: {
    if (rankings.length == 4) {
      canSubmit = true;
    } else {
      canSubmit = false;
    }
  }

  import {
    topFourDepartments,
    budgetBlocks,
    selectedPerformanceMeasures,
  } from "@stores/userData.js";

  let buttonText = "Submit";
  import navigateToHash from "@helpers/navigateToHash.js";
  const handleSubmit = function () {
    buttonText = "Thanks!";

    topFourDepartments.set(rankings);
    budgetBlocks.set([]);
    // selectedPerformanceMeasures.set([]);

    // localStorage.removeItem("budgetBlocks");
    // localStorage.removeItem("selectedPerformanceMeasures");
    navigateToHash("outcomes-intro", 500);
  };

  import Card from "./Card.svelte";
</script>

<div class="dropzones">
  <div class="budget">
    <!-- Text input/search box that filters budget.items -->
    <input
      type="text"
      class="search"
      placeholder="Search departments (e.g. Houston Health Department)"
      on:input={(e) => {
        departmentsAfterSearch = departmentsWithSearchText.filter((item) => {
          return item.searchText.includes(e.target.value.toLowerCase());
        });
        if (e.target.value.length == 0) {
          departmentsAfterSearch = filteredItems.slice();
        }
      }}
    />
    <div class="departments scrollbar-hidden" class:showAll>
      {#each departmentsAfterSearch as item}
        <Card bind:rankings data={item} />
      {/each}
    </div>
    <!-- <div class="scrim-gradient" /> -->
    <div class="show-button">
      <ButtonContainer fontSize=".85rem"
        ><button
          on:click={() => {
            showAll = !showAll;
          }}>{showAll ? "Hide" : "Show"} others</button
        ></ButtonContainer
      >
    </div>
  </div>
</div>

<ButtonContainer
  disabled={!canSubmit}
  disabledReason={`${rankings.length} out of 4 selected!`}
>
  <button
    disabled={!canSubmit}
    class:disabled={!canSubmit}
    on:click={handleSubmit}
  >
    {buttonText}</button
  >
</ButtonContainer>

<style>
  /* LARGE FLEX WRAPPER CONTAINER */
  .dropzones {
    margin: 2rem 0;
    display: flex;
    width: 100%;
    max-width: 1068px;
  }

  .budget {
    position: relative;
  }

  .budget {
    /* background: rgba(var(--primary-color-rgb), 0.8);
    box-shadow: 1px 1px 4px rgba(var(--text-color-rgb), 0.5); */
    width: 100%;
  }

  .budget .departments {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
    grid-auto-rows: minmax(min-content, max-content);
    grid-gap: 0.75rem; /* https://caniuse.com/?search=grid-gap */
    margin-top: 0.75rem;
    padding: 3px 3px 5rem 3px; /* For show more button + to show border on sides */
    /* max-height: 610px; */
  }

  .showAll {
    max-height: 610px;
    overflow: scroll;
  }

  .show-button {
    position: absolute;
    bottom: 0;
    left: 0;
  }

  @media screen and (max-width: 768px) {
    .dropzones {
      flex-direction: column;
      width: 100%;
    }
    .budget {
      margin-right: 0;
      margin-bottom: 1rem;
    }
  }

  .search {
    border: none;
    font-size: 1.25rem;
    font-family: var(--font-serif);
    font-weight: 200;
    width: 100%;
    padding: 0.5rem;
    background: var(--primary-color-base);
    margin-bottom: 0.5rem;
    outline: 1px solid var(--accent-color);
  }

  .search:focus,
  .search:active {
    border: none;
    outline: 1px solid var(--accent-color);
  }

  /* @media screen and (max-width: 890px) {
    .budget .departments {
      height: 800px;
    }
  } */

  /* @media screen and (max-width: 668px) {
    .budget .departments {
      height: 400px;
      overflow: scroll;
    }
  } */

  @media screen and (max-width: 468px) {
    .budget .departments {
      grid-template-columns: repeat(auto-fill, minmax(90vw, 1fr));
    }
  }
</style>
